// extracted by mini-css-extract-plugin
export default {"root":"ReviewCard_root__TasMt","header":"ReviewCard_header__y20Jx","kicker":"ReviewCard_kicker__Amvpc","quote":"ReviewCard_quote__0lXfq"};